import { z } from "zod/v4"
import { DocumentSnapshotLike } from "../firestore"
import { UserDenormalizedWithoutLook, Users } from "./user"
import { CreatedAt, UpdatedAt } from "./system"
import { LiveIdSchema, SpaceKeySchema, UserId, UserIdSchema } from "../id"

export const LivePowerSummaryIdSchema = UserIdSchema
export type LivePowerSummaryId = UserId

export function LivePowerSummaryId(value: string): LivePowerSummaryId {
  return value as LivePowerSummaryId
}

export const LivePowerSummaryDocumentBody = z.object({
  space_key: SpaceKeySchema,
  live_id: LiveIdSchema,
  user: UserDenormalizedWithoutLook,
  total_price: z.number().describe("パワーの価格の合計値。"),
  total_impact: z.number().describe("パワーの影響値の合計値。"),
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export const LivePowerSummaryDocument = z.intersection(
  LivePowerSummaryDocumentBody,
  z.object({
    id: LivePowerSummaryIdSchema,
  })
)

export type LivePowerSummaryDocument = z.infer<typeof LivePowerSummaryDocument>

export class LivePowerSummaries {
  static toDocumentData(doc: LivePowerSummaryDocument): object {
    return {
      ...doc,
      // id は document path に入るので入れない
      id: undefined,
    }
  }


  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): LivePowerSummaryDocument | null {
    if (!doc) {
      return null
    }

    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: LivePowerSummaryId(doc.id),
      space_key: data["space_key"],
      live_id: data["live_id"],
      user: data["user"] ? Users.parseDenormalizedWithoutLook(data["user"]) : data["user"],
      total_price: data["total_price"],
      total_impact: data["total_impact"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}

export const LivePowerSummaryDocuments = LivePowerSummaries
